export default "__VITE_PUBLIC_ASSET__d5cd4cdd__"